import common from './common'
import home from './home'
import about from './about'
import contact from './contact'
import knowledge from './knowledge'
import businessServices from './businessServices'
import legalServices from './legalServices'
import hkRegistration from './hkRegistration'
import offshoreRegistration from './offshoreRegistration'
import odiInvestment from './odiInvestment'
import vieStructure from './vieStructure'

export default {
  common,
  home,
  about,
  contact,
  knowledge,
  businessServices,
  legalServices,
  hkRegistration,
  offshoreRegistration,
  odiInvestment,
  vieStructure,
  ...common, // 展开顶级的 navBar, footer, sideBar 等
}
